import { useContext } from 'react'
import { NavigationPanelContext } from '../../contexts/navigationPanelContext'

/**
 * Хук для использования контекста навигационной панели
 * @returns Контекст панели с состоянием и функциями управления
 * @throws Ошибка, если хук используется вне NavigationPanelProvider
 */
export function useNavigationPanel() {
  const context = useContext(NavigationPanelContext)

  if (context === undefined) {
    throw new Error('useNavigationPanel must be used within a NavigationPanelProvider')
  }

  return context
}